import React from "react";
var __jsx = React.createElement;
import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import FiveCard from './FiveCard';
function FiveCardAdapter(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  var fiveCardData = useContentfulLiveUpdates(entry);
  return __jsx(FiveCard, {
    fiveCardData: fiveCardData,
    scrollbarWidth: data.scrollbarWidth,
    themeName: data.siteData.theme
  });
}
export default FiveCardAdapter;